<script lang="ts" setup>
import type { HTMLAttributes } from 'vue';
import { cn } from '@/libs/css';

const props = defineProps<{
  size: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  level?: 2 | 3 | 4 | 5 | 6;
  class?: HTMLAttributes['class'];
}>();

const level = computed(() => {
  if (props.level) return props.level;
  return {
    sm: 4,
    md: 3,
    lg: 2,
    xl: 2,
    '2xl': 2,
  }[props.size];
});
</script>

<template>
  <component
    :is="`h${level}`"
    :class="
      cn(
        // this class is for the BaseProse component
        `base-heading-${size}`,
        'm-0 font-medium',
        {
          'text-base': size === 'sm',
          'text-md': size === 'md',
          'text-lg font-[480]': size === 'lg',
          'text-xl font-[460]': size === 'xl',
          'text-2xl font-[440]': size === '2xl',
        },
        props.class,
      )
    "
  >
    <slot />
  </component>
</template>
